"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var reselect_1 = require("reselect");

var tableSelectors = __importStar(require("./tableSelectors"));

exports.getTableList = function (tables) {
  return tables || [];
};

exports.getTableById = reselect_1.createSelector(exports.getTableList, function (_, tableId) {
  return tableId;
}, function (tables, tableId) {
  return tables && tables.find(function (_ref) {
    var id = _ref.id;
    return id === tableId;
  });
});
exports.getTableByName = reselect_1.createSelector(exports.getTableList, function (_, tableName) {
  return tableName;
}, function (_, __, applicationName) {
  return applicationName;
}, function (tables, tableName, appName) {
  return tables && tables.filter(function (_ref2) {
    var application = _ref2.application;
    return application && appName ? application.name.toLowerCase() === appName.toLowerCase() : !appName;
  }).find(function (_ref3) {
    var name = _ref3.name;
    return name.toLowerCase() === tableName.toLowerCase();
  });
});
exports.getTableApplication = reselect_1.createSelector(exports.getTableById, function (table) {
  return table && table.application;
});
exports.getTableFields = reselect_1.createSelector(exports.getTableById, function (table) {
  return table ? table.fields : [];
});
exports.getTableApplicationName = reselect_1.createSelector(exports.getTableApplication, function (table) {
  return table ? table.name : '';
});
exports.getNoSystemTables = reselect_1.createSelector(exports.getTableList, function (tablesList) {
  return tablesList.filter(function (_ref4) {
    var isSystem = _ref4.isSystem;
    return !isSystem;
  });
});
exports.getSystemTables = reselect_1.createSelector(exports.getTableList, function (tablesList) {
  return tablesList.filter(tableSelectors.isSystemTable);
});
exports.hasNoSystemTables = reselect_1.createSelector(exports.getNoSystemTables, function (tables) {
  return tables.length > 0;
});
exports.getUserTables = reselect_1.createSelector(exports.getTableList, function (tablesList) {
  return tablesList.filter(tableSelectors.isUserTable);
});
exports.getApplicationTables = reselect_1.createSelector(exports.getTableList, function (tablesList) {
  return tablesList.filter(function (_ref5) {
    var application = _ref5.application;
    return !!application;
  });
});
exports.getViewTables = reselect_1.createSelector(exports.getTableList, function (tablesList) {
  return tablesList.filter(tableSelectors.isViewTable);
});
exports.getTablesByApplicationName = reselect_1.createSelector(exports.getTableList, function (_, appName) {
  return appName;
}, function (tablesList, appName) {
  return tablesList.filter(function (_ref6) {
    var application = _ref6.application;
    return application && application.name === appName;
  });
});
exports.getTablesByApplicationId = reselect_1.createSelector(exports.getTableList, function (_, appId) {
  return appId;
}, function (tablesList, appId) {
  return tablesList.filter(function (_ref7) {
    var application = _ref7.application;
    return application && application.id === appId;
  });
});
exports.hasUserTables = reselect_1.createSelector(exports.getUserTables, function (tables) {
  return tables.length > 0;
});